<section class="subheader doble-m">
    <img onerror="this.src='./assets/img/default.png'" class=" desk img-title w-100 "
        src="../../../../../assets/img/img-interna.jpg">
    <img onerror="this.src='./assets/img/default.png'" class="mob img-title w-100 "
        src="../../../../../assets/img/img-interna.jpg">
    <div class="texto-s container">
        <div class='row'>
            <div class='col'>
                <h3 class="fs-21 c-principal bold">Año {{year}}</h3>
                <h1 class="azul">Todos los eventos</h1>
            </div>
        </div>
        <div class="carousel-container carousel-moving">
            <div class='years'>
                <a [href]="'/es/calendario/1/'+lastYear" style='margin-bottom: 10px;'> <span
                        style='margin-bottom: 3%;float: left;' class="fs-16 c-principal bold">
                        <i class="fas fa-chevron-left"></i>
                        {{lastYear}}
                    </span>
                </a>
                <a [href]="'/es/calendario/1/'+nextYear" style='margin-bottom: 10px;'><span
                        style='margin-bottom: 3%;float: right;' class="fs-16 c-principal bold">
                        {{nextYear}}
                        <i class="fas fa-chevron-right"></i>
                    </span>
                </a>
            </div>

            <app-carousel-calendar [month]="month" [year]="year"
                style='display:flex;min-height: 100px;height: 100px;'></app-carousel-calendar>

        </div>
    </div>
</section>
<section>
    <div class="row calendar-container mx-3 mx-md-5">
        <div *ngIf="events" class="col-lg-8 calendar-size mt-5 pl-md-5">
            <app-calendar [month]=month [year]="year" [events]=events></app-calendar>
        </div>
        <div class="col-lg-4 " *ngIf='lastEvents'>
            <app-custom-diary-general title='Proximos eventos' [data]='lastEvents' boton='false'>
            </app-custom-diary-general>
        </div>
    </div>


</section>